import * as React from 'react';
import styled from 'styled-components';

import { loadJSData } from '../../shared/jsData';
import t from '../../shared/translations';

const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-top: 1px solid black;
    padding: 5px 0;
    max-width: 1024px;
    width: 100%;
    @media (min-width: 600px) {
        flex-direction: row;
        align-items: center;
        > * {
            width: 50%;
        }
    }
    > * {
        text-align: center;
        font-size: 0.9em;
    }
`;

const FooterLogo = styled.img`
    max-height: 2rem;
    max-width: 290px;
    object-fit: scale-down;

    @media (min-width: 600px) {
        max-width: 33%;
    }
`;

function Footer(): JSX.Element {
    const logoSrc = loadJSData().settings.logo_src;
    return <FooterWrapper>
        <div>
            <FooterLogo src={logoSrc} />
        </div>
        <div>{t('shared.footer.copyright')}</div>
    </FooterWrapper>;
}

export default Footer;
